import { useNavigate } from "react-router-dom";
import { IWidgets } from "../../../../models/master/widgets";
import { IStudentResources } from "../../../../models/student/studentAccountsDetails";
import { connect, useDispatch } from "react-redux";
import { useEffect } from "react";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { setWidgets } from "../../../../store/slices/master/widgetSlice";
import { getWidgets } from "../../../../action/masters/widgetActionCreator";
import { baseURL } from "../../../../constants/commonConstants";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const StudentResources = (props: IStudentResources) => {
  const { getAllWidgets, widgets, snapShots } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.accountResources);

  useEffect(() => {
    dispatch(setWidgets([]))
    if (pageBlockData?.displayOrNot) {
      getAllWidgets(pageBlockId.accountResources, limit.ten);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setWidgets([]))
    }
  }, []);

  const handleViewAll = () => {
    navigate(ROUTER_URL.STUDENT_RESOURCE_VIEW_ALL);
  }

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Account Resources</h2>
          <a onClick={() => handleViewAll()} className={
                pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
              }>
            View All
          </a>
        </div>
        <div className="acc-resource mt-3 row">
          {widgets
            ?.filter((widget: IWidgets) => widget.displayOrNot)
            .map((widget: IWidgets) => (
              <div className="col-lg-6 mb-3" key={widget.id}>
                <a href={widget.url} target="_blank" rel="noopener noreferrer">
                  <div className="card">
                    <div className="img">
                      <img
                        src={baseURL + widget.image}
                        alt={widget.name}
                        onError={(e) => {
                          e.currentTarget.src = "/assets/images/icon/book.svg";
                        }}
                      />
                    </div>
                    <div className="desc">
                      <h2 className="para-hide-1">{widget.name}</h2>
                      <p className="para-hide-1">{widget.description}</p>
                    </div>
                  </div>
                </a>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getAllWidgets: (pageBlockId?: number, noOfItems?: number) =>
    getWidgets(undefined, pageBlockId, undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    widgets: state.widget.widgets,
    snapShots: state.snapShot.snapShots,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(StudentResources);
